import React from 'react';
//@ts-ignore
import * as styles from './blog-breadcrumbs.module.css';
import { BlogBreadcrumbsProps } from './index';
import { getMultiChoice } from '../Global/DataUtils';
import Lotus from '../Global/Lotus';
import { IconNode } from '../Global/DataUtils/iconQueries';
import { navigate } from 'gatsby-link';

interface Props extends BlogBreadcrumbsProps {
    icon?: IconNode;
    preferredLanguage?: string;
}

const BlogBreadcrumbs: React.FC<Props> = ({
    blog_home_page,
    blog_topic,
    headline,
    return_home_label,
    view_more_copy,
    icon,
}) => {
    const blogHomePageUrl = `${blog_home_page.value[0]?.elements?.slug?.url}`;
    const blogHomePageNoFollow =
        getMultiChoice(blog_home_page.value[0]?.elements?.no_follow) === 'yes'
            ? 'nofollow'
            : undefined;
    const blogTopic = blog_topic?.value[0];
    const iconData = icon?.node?.elements?.icon_svg_file?.value[0];
    const iconColor = icon?.node?.elements?.color?.value[0]?.codename;
    const iconStyle =
        iconColor != 'dark_gray' ? { filter: 'grayscale(100%)' } : {};

    const renderLotus = () => {
        return (
            <div className={styles.icon}>
                <Lotus fillColor="#505251" heightWidth="1.25rem" />
            </div>
        );
    };

    const handleClickBlogTopic = (event: React.MouseEvent) => {
        event.preventDefault();
        navigate(blogHomePageUrl, {
            state: {
                filter: blogTopic,
            },
        });
    };

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>{headline.value}</h2>
            <ul className={styles.breadcrumbList}>
                {blogTopic && (
                    <li>
                        <a
                            href={`${blogHomePageUrl}`}
                            target="_self"
                            data-topic={blogTopic.codename}
                            onClick={handleClickBlogTopic}
                        >
                            {iconData ? (
                                <object
                                    type="image/svg+xml"
                                    data={iconData.url}
                                    className={styles.icon}
                                    style={iconStyle}
                                >
                                    <img
                                        src={iconData.url}
                                        alt={iconData.description}
                                    />
                                </object>
                            ) : (
                                renderLotus()
                            )}
                            {view_more_copy.value} {blogTopic.name}
                        </a>
                    </li>
                )}
                <li>
                    <a
                        href={blogHomePageUrl}
                        rel={blogHomePageNoFollow}
                        target="_self"
                    >
                        {renderLotus()}
                        {return_home_label.value}
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default BlogBreadcrumbs;
